<style lang="sass">
@import ../../../common/styles/mixins
@import ../../../common/styles/settings
@import menu-main
</style>
<script>
/*
import ResizeObserver from "resize-observer-polyfill";
import { debounce, throttle } from "lodash";
*/

import $ from "jquery";

export default {
  name: "MenuMain",
  data() {
    return {
      isRuptured: false,
      width: 0,
      linksSource: [],
      linksMain: [],
      linksExtra: [],
      more: null,
      moreWidth: 0,
      showMore: false,
      ruptureIndex: -1,
      isOpen: [],
      targets: [],
      disclaimer: false,
      currentMenu: null,
    };
  },
  computed: {
    classes() {
      return [
        "menu-main",
        {
          "menu-main-disclaimer": this.disclaimer,
        },
      ];
    },
    isDesktop() {
      return window.innerWidth >= 960;
    },
    isPro() {
      return window.location.pathname.includes("/pro");
    },
  },

  mounted() {
    if (this.isDesktop) {
      let element = $("li.menu-main__menu-desktop");
      if (element.length > 0) {
        element.appendTo(element.parent());
      }
    } else {
      let menuFirstLevel = document.querySelectorAll("li.menu-main__item--1 > span.menu-main__link-wrapper > a");

      // Parcourir la liste des balises <a>
      menuFirstLevel.forEach((link) => {
        let parentSpan = link.parentElement;
        if (
          parentSpan &&
          parentSpan.tagName.toLowerCase() === "span" &&
          parentSpan.parentElement &&
          Array.from(parentSpan.parentElement.children).some(
            sibling => sibling !== parentSpan && sibling.classList.contains("menu-main__wrapper")
          )
        ) {
          const button = document.createElement("button");
          button.innerHTML = link.innerHTML;
          button.classList.add(...link.classList);
          
          const testValue = link.getAttribute("data-drupal-link-system-path");
          if (testValue) {
            button.setAttribute("data-drupal-link-system-path", testValue);
          }
          parentSpan.replaceChild(button, link);
        }
      });
    }

    if (document.getElementsByClassName("menu-disclaimer").length > 0) {
      if (window.innerWidth < 960) {
        let menumain = document.getElementsByClassName("menu-main")[0];
        menumain.classList.add("menu-main-disclaimer");

        document.querySelectorAll("li.menu-main__item.menu-main__item--1 > span > a").forEach(function (element) {
          let parentSpan = element.parentElement;
          if (
            parentSpan.tagName.toLowerCase() === "span" &&
            parentSpan.parentElement &&
            Array.from(parentSpan.parentElement.children).some(
              sibling => sibling !== parentSpan && sibling.classList.contains("menu-main__link-wrapper")
            )
          ) {
            element.removeAttribute("href");
          }
        });
      }
    }

    this.$nextTick(() => {
      if (this.isDesktop) {
        this.updateMenu();
        this.watchResize();
      } else {
        this.addAnalyticsClickListener(this.$refs.mainPanel);
      }
    });
  },
  beforeDestroy() {
    this.collapsibles.forEach((collapsible) => {
      const link = collapsible.querySelector("menu-main__link--2");
      this.unsetClickEvent(link);
    });
    window.removeEventListener("resize", this.onResize.bind(this));
  },
  methods: {
    addAnalyticsClickListener(target) {
      // Looking for all <a> tag and attach click event
      const links = target.getElementsByTagName("a");
      //console.log(target.getElementsByTagName('a'));
      for (const link of links) {
        if (link.getAttribute("href")) {
          link.addEventListener(
            "click",
            function () {
              this.sendAnalyticsEvent(link);
            }.bind(this)
          );
        }
      }
    },

    sendAnalyticsEvent(target) {
      // We just want send event on <a> element (Redirection link)
      if (target.tagName.toLowerCase() === "a") {
        // Get parent data set
        const dataSet = target.parentNode.parentNode.dataset;

        // We just want send event on element that have menuAnalytics dataset
        if (dataSet && dataSet.menuAnalytics !== "undefined") {
          const isExt = target.getAttribute("target");
          const isDownload = target.getAttribute("download");

          // Define click type
          let clickType = "navigation";
          if (isExt !== null && isExt === "_blank") {
            clickType = "exit";
          } else if (isDownload !== null) {
            clickType = "download";
          }

          const itemToPush = {
            event: "click",
            click: dataSet.menuTitle
              .replace(/["+?!]/g, "")
              .replace(/[#_', ]/g, "_")
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, ""),
            click_type: clickType,
            event_location: "header",
          };

          if (clickType === "navigation" && dataSet.menuLevel > 1) {
            // Get base parent (First menu item)
            const baseParentNode = target.closest(
              `li.menu-main__item.menu-main__item--1`
            );

            // Obtaining all upper chapters
            for (let i = dataSet.menuLevel - 1; i > 0; i--) {
              if (i > 1) {
                // Get parent for expanded menu which is open
                let parentNode;
                if (this.isDesktop) {
                  parentNode = baseParentNode.querySelector(
                    `ul.menu-main--${i} > li.menu-main__item--${i}.menu-main__item--open`
                  );
                } else {
                  parentNode = baseParentNode.querySelector(
                    `ul.menu-main--${i} > li.menu-main__item--${i}.menu-main__item--active`
                  );
                }

                itemToPush["click_chapter" + i] = parentNode.dataset.menuTitle;
              } else {
                itemToPush["click_chapter" + i] =
                  baseParentNode.dataset.menuTitle;
              }
            }
          }

          window.dataLayer.push(itemToPush);
        }
      }
    },
    updateMenu() {
      this.updateWidth();
      this.fetchLinksSource();
      this.rupture();
    },
    updateWidth() {
      this.width = jQuery(document).width() - jQuery(this.$el).offset().left;
    },
    watchResize() {
      window.addEventListener("resize", this.onResize.bind(this));
    },
    onResize() {
      this.clearLinks();
      this.resetMenu();
      this.updateMenu();
    },
    fetchLinksSource() {
      this.linksSource = [...this.$el.children].map((link) => ({
        $el: link,
        width: link.offsetWidth,
      }));
      if (!this.more) {
        this.more = this.linksSource.pop().$el;
        this.moreWidth = jQuery(this.more).outerWidth(true);
      }
    },
    rupture() {
      this.setRuptureIndex();
      this.isRuptured = this.ruptureIndex < this.linksSource.length - 1;
      this.linksMain = this.linksSource.map((link) => {
        const node = link.$el.cloneNode(true);

        this.addAnalyticsClickListener(node);

        return node;
      });
      this.linksExtra = this.isRuptured
        ? this.linksMain.splice(this.ruptureIndex + 1)
        : [];
      this.clearLinks();
      this.redrawMenu();
    },
    resetMenu() {
      const { mainPanel } = this.$refs;
      this.linksSource.forEach((link) => {
        mainPanel.append(link.$el);
      });
    },
    setRuptureIndex() {
      const checkRupture = (result, link, index) => {
        let width =
          index === this.linksSource.length - 1
            ? this.width
            : this.width - this.moreWidth;
        result.width += link.width;
        if (result.width < width) {
          result.rupture = index;
        }
        return result;
      };
      const ruptureStatus = this.linksSource.reduce(checkRupture, {
        width: 0,
        rupture: -1,
      });
      this.ruptureIndex = ruptureStatus.rupture;
    },
    clearLinks() {
      const { mainPanel, morePanel } = this.$refs;
      while (mainPanel.firstChild) {
        mainPanel.firstChild.remove();
      }
      while (morePanel.firstChild) {
        morePanel.firstChild.remove();
      }
    },
    redrawMenu() {
      const { mainPanel, morePanel } = this.$refs;
      if (this.isRuptured) {
        this.linksMain.push(this.more);
      }
      this.linksMain.forEach((link) => {
        mainPanel.append(link);
      });
      this.linksExtra.forEach((link) => {
        morePanel.append(link);
      });
    },
    toggleMenuExtra() {
      this.showMore = !this.showMore;
    },
    menuItemHover(event) {
      let target = event.target;
      if (this.showMore) {
        // If the element is a first-level li and is not in menu more, hide the menu more
        if (
          target.parentNode === this.$el &&
          target.classList.contains("menu-main__item")
        ) {
          this.showMore = false;
        }
      }

      if (
        target.closest(".menu-main__more") === null &&
        target.classList.contains("menu-main__item")
      ) {
        if (!this.targets.includes(target)) {
          this.showSubMenu(target);
          this.targets.push(target);
        }
      }
    },
    showSubMenu(item) {
      if (
        item.querySelector(".menu-main--2") &&
        item.querySelector(".menu-main--2").querySelectorAll(".header_title")
          .length > 0
      ) {
        const children = item.querySelector(".menu-main--2").children;
        const titlesCount = item
          .querySelector(".menu-main--2")
          .querySelectorAll(".header_title").length;
        let elementsList = [];

        for (let i = 0; i < titlesCount; i++) {
          let ul = document.createElement("ul");
          let classesToAdd = ["menu-main--" + (i + 2).toString()];
          ul.classList.add(...classesToAdd);
          elementsList.push(ul);
        }

        let j = -1;

        if (!this.flag) {
          for (let i = 0; i < children.length; i++) {
            children[i].querySelector(".header_title") ? (j += 1) : null;

            let newel = children[i].cloneNode(true);
            elementsList[j].appendChild(newel);
          }
        }
        item.querySelector(".menu-main--2").remove();

        elementsList.forEach((el) => {
          let eltoadd = el.cloneNode(true);
          item.querySelector(".menu-main__wrapper").appendChild(eltoadd);
        });
      }
    },
    changePanel(event) {
      if (!this.isDesktop) {
        let menuName = null;
        const activeItems = document.querySelectorAll(
          "li.menu-main__item--active.menu-main__item--1"
        );

        // Close open menus and hide their submenus
        if (activeItems.length > 0 && !event.target.getAttribute("href")) {
          this.changeClosePanelIcon();
          activeItems.forEach(function (element) {
            element.classList.remove("menu-main__item--active");
            const submenu = element.querySelector(
              ".menu-main--2, .menu-main--3"
            );
            if (submenu) {
              submenu.style.display = "none";
            }
          });
        }

        if (event.target.parentNode.parentNode) {
          switch ("LI") {
            case event.target.tagName:
              event.target.classList.add("menu-main__item--active");
              menuName = event.target.dataset.menuTitle;
              break;
            case event.target.parentNode.tagName:
              event.target.parentNode.classList.add("menu-main__item--active");
              menuName = event.target.parentNode.dataset.menuTitle;
              break;
            case event.target.parentNode.parentNode.tagName:
              event.target.parentNode.parentNode.classList.add(
                "menu-main__item--active"
              );
              menuName = event.target.parentNode.parentNode.dataset.menuTitle;
              break;
          }
        }

        if (menuName) {
          const activeMenuItem = document.querySelector(
            "li.menu-main__item--active"
          );
          if (activeMenuItem) {
            const submenu = activeMenuItem.querySelector(
              ".menu-main--2, .menu-main--3"
            );
            if (submenu) {
              submenu.style.display = "block";
            }
          }
        }

        if (!this.currentMenu || this.currentMenu != menuName) {
          this.currentMenu = menuName;
          this.changeOpenPanelIcon();
        } else if (
          this.currentMenu == menuName &&
          !event.target.getAttribute("href")
        ) {
          this.changeClosePanelIcon();
          const activeItem = document.querySelector(
            "li.menu-main__item--active"
          );
          if (activeItem) {
            activeItem.classList.remove("menu-main__item--active");
            const submenu = activeItem.querySelector(
              ".menu-main--2, .menu-main--3"
            );
            if (submenu) {
              submenu.style.display = "none";
            }
          }
          this.currentMenu = null;
        }
      }
    },
    changeOpenPanelIcon() {
      let oldSvg = document
        .querySelector("li.menu-main__item--active>span")
        .querySelector("svg");
      let newSvg = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "svg"
      );
      newSvg.setAttribute("width", "16");
      newSvg.setAttribute("height", "9");
      newSvg.setAttribute("viewBox", "0 0 16 9");
      newSvg.setAttribute("fill", "none");

      let newPath = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "path"
      );
      newPath.setAttribute("fill-rule", "evenodd");
      newPath.setAttribute("clip-rule", "evenodd");
      newPath.setAttribute(
        "d",
        "M0.195262 8.80474C0.455611 9.1651 0.877721 9.1651 1.13807 8.80474L8 1.94282L14.8619 8.80474C15.1223 9.1651 15.5444 9.1651 15.8047 8.80474C16.0651 8.44439 16.0651 8.02228 15.8047 7.76193L8.47141 0.328601C8.21106 0.0682523 7.78895 0.0682523 7.5286 0.328601L0.195262 7.76193C-0.0650877 8.02228 -0.0650877 8.44439 0.195262 8.80474Z"
      );
      newSvg.appendChild(newPath);
      if (oldSvg) {
        document
          .querySelector("li.menu-main__item--active>span")
          .replaceChild(newSvg, oldSvg);
      }
    },
    changeClosePanelIcon() {
      let oldSvg = document
        .querySelector("li.menu-main__item--active>span")
        .querySelector("svg");
      let newSvg = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "svg"
      );
      newSvg.setAttribute("width", "16");
      newSvg.setAttribute("height", "9");
      newSvg.setAttribute("viewBox", "0 0 16 9");
      newSvg.setAttribute("fill", "none");
      let newPath = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "path"
      );
      newPath.setAttribute("fill-rule", "evenodd");
      newPath.setAttribute("clip-rule", "evenodd");
      newPath.setAttribute(
        "d",
        "M0.195262 0.195254C0.455611 -0.0650959 0.877721 -0.0650959 1.13807 0.195254L8 7.05718L14.8619 0.195254C15.1223 -0.0650966 15.5444 -0.0650966 15.8047 0.195254C16.0651 0.455603 16.0651 0.877713 15.8047 1.13806L8.47141 8.47139C8.21106 8.73174 7.78895 8.73174 7.5286 8.47139L0.195262 1.13806C-0.0650877 0.877713 -0.0650877 0.455604 0.195262 0.195254Z"
      );
      newSvg.appendChild(newPath);
      if (oldSvg) {
        document
          .querySelector("li.menu-main__item--active>span")
          .replaceChild(newSvg, oldSvg);
      }
    },
  },
};
</script>
